/**
 * projectCache — Cache IndexedDB para dados de projetos (stale-while-revalidate)
 *
 * Usa CacheManager (L1 Memory + L2 IndexedDB) para servir dados
 * instantaneamente do cache e revalidar em background.
 */
import { createBigwaCache } from '../../core/cache';
import type { ProjectReference, ProjectResearchData } from './types';

// L1: 5 min (session), L2: 24h (IndexedDB, revalida em background)
export const refsCache = createBigwaCache<ProjectReference[]>(
  'project-refs',
  5 * 60 * 1000,
  24 * 60 * 60 * 1000
);

export const researchCache = createBigwaCache<ProjectResearchData[]>(
  'project-research',
  5 * 60 * 1000,
  24 * 60 * 60 * 1000
);

/**
 * Gera chave de cache isolada por usuário + projeto
 */
export function getCacheKey(prefix: string, projectId: string): string {
  let userId = 'unknown';
  try {
    const userStr = localStorage.getItem('bigwa_user');
    if (userStr) {
      const user = JSON.parse(userStr);
      userId = user.email || 'unknown';
    }
  } catch { /* ignore */ }
  return `${prefix}:${userId}:${projectId}`;
}
